import { HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { AccountService } from '@services/account.service'
import { PcaApiService } from '@services/api/pca-api-base.service'
import { AccountProductId, AccountProductType } from '@models/account.model'
import { environment as env } from '@envs/environment'
import { isApiUrl } from '@utils/api-origin.util'

/** `x-product-id` por produto; o resto sai como Gestão. */
const PRODUCT_HEADER: Partial<Record<AccountProductType, AccountProductId>> = {
	[AccountProductType.SUP]: AccountProductId.SUPPLIER,
	[AccountProductType.SIG]: AccountProductId.SIGNER,
	[AccountProductType.VIS]: AccountProductId.VISITOR
}

/** Produtos sem órgão: nunca levam `x-tenant-id`, nem com uma conta de órgão no `localStorage` (RF 37, spec 048). */
const WITHOUT_TENANT = [AccountProductType.SUP, AccountProductType.VIS]

export const ClientInterceptor: HttpInterceptorFn = (request, next) => {
	const signin = request.url.includes('signin')

	// Fora das APIs da SilGov (S3, viacep, qualquer outro host), nenhum cabeçalho nosso: no POST direto ao S3 eles
	// quebrariam a assinatura e o CORS.
	if (request.url.includes('auth') || signin || !isApiUrl(request.url)) {
		return next(request)
	}

	const accountService = inject(AccountService)
	const product = accountService.currentProduct
	const tenantId = accountService.tenantId

	const headersToSet: { [key: string]: string } = {}

	if (tenantId && !WITHOUT_TENANT.includes(product?.type)) {
		headersToSet['x-tenant-id'] = tenantId
	}

	if (request.url.startsWith(env.url_pca_api) || request.url.startsWith(env.url_management_api)) {
		headersToSet['x-product-id'] = PRODUCT_HEADER[product?.type] ?? AccountProductId.MANAGEMENT
	}

	if (Object.keys(headersToSet).length) {
		const headers = PcaApiService.updateHeaders(request, headersToSet)
		return next(request.clone({ headers }))
	}

	return next(request)
}
